<template>
  <tr
    class="v-datatable__row"
  >
    <td class="text-xs-left">
      <v-checkbox
        v-model="props.selected"
        hide-details
      />
    </td>
    <td>{{ props.item.order }}</td>
    <td>
      <v-img
        :src="$helpers.imageFrom(props.item, 'tiny')"
        class="my-1"
        max-height="55"
        max-width="55"
      />
    </td>

    <td>
      <router-link
        :to="{
          name: 'single-product',
          params: { id: props.item.id }
        }"
        class="text-no-wrap"
      >
        {{ props.item.sku }}
      </router-link>
    </td>
    <td>{{ props.item.name }}</td>
    <td>{{ props.item.classification }}</td>
    <td class="text-no-wrap">{{ props.item.price | money }}</td>
    <td
      v-if="props.item.sale_price"
      class="text-no-wrap">
      {{ props.item.sale_price | money }}
    </td>
    <td
      v-else
      class="text-no-wrap">-
    </td>
    <template v-if="taxType === 'vat'">
      <td class="text-no-wrap">{{ props.item.gross_price | money }}</td>

      <td
        v-if="props.item.gross_sale_price"
        class="text-no-wrap">
        {{ props.item.gross_sale_price | money }}
      </td>
      <td
        v-else
        class="text-no-wrap">-
      </td>
    </template>
    <td >{{ props.item.inventory.quantity }}</td>
    <td >{{ props.item.created_at | timezone }}</td>
  </tr>
</template>
<script>
export default {
  name: 'ProductDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    },

    taxType: {
      type: String,
      default: 'sales'
    }
  }
}
</script>
